// HRM_CLEANUP: Delete this entire file and ConfidentialityStatementButton.module.scss when Ontario MD certification is complete
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { Icon } from "@/DesignSystem/Atoms/Icons/Icon/Icon";

import FileTextBold from "@/DesignSystem/Atoms/Icons/Types/FileText/file-text-bold.svg";
import styles from "./ConfidentialityStatementButton.module.scss";

interface IConfidentialityStatementButtonProps {
    onClickOperation?: number;
    onClick?: () => void;
    className?: string;
    rightMargin?: number;
    isDisabled?: boolean;
    dataCy?: string;
}

class ConfidentialityStatementButton extends React.Component<IConfidentialityStatementButtonProps> {
    public render(): JSX.Element {
        const buttonClassName = this.props.className + " button control";
        const buttonClassNameWithMargin = this.props.rightMargin != null && this.props.rightMargin >= 0
            ? `${buttonClassName} ${styles.buttonWithMargin}`
            : buttonClassName;

        const buttonStyle = this.props.rightMargin != null && this.props.rightMargin >= 0
            ? { "--right-margin": `${this.props.rightMargin}px` } as React.CSSProperties
            : undefined;

        return (
            <button
                disabled={this.props.isDisabled}
                className={buttonClassNameWithMargin}
                style={buttonStyle}
                onClick={this.handleClick.bind(this)}
                data-cy={this.props.dataCy}
                title="Confidentiality Statement"
            >
                <span className={styles.iconContainer}>
                    <Icon size="md" colorVariant="brand">
                        <FileTextBold className={styles.iconSvg} />
                    </Icon>
                </span>
            </button>
        );
    }

    public handleClick(event: React.MouseEvent): void {
        event.stopPropagation();

        if (this.props.onClickOperation != null)
            LocalEvent.Dispatch(this.props.onClickOperation);

        if (this.props.onClick != null)
            this.props.onClick();
    }
}

export { ConfidentialityStatementButton };
